import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { loginFromAdminRequest } from "../../shared/services/auth/auth.service";
import AuthContext from "../../shared/context/authContext/AuthContext";
import { ACTIONS } from "../../shared/context/authContext/Constants";
import { updateAnalytics } from "../../shared/services/analytics/analytics.service";
import {
    clearLocalStorage,
    storeSessionToken,
} from "../../shared/services/auth/auth.service";
import { toast } from "react-toastify";

const LoginFromAdmin = () => {
    const { dispatch } = useContext(AuthContext);
    const history = useHistory();

    const handleInit = async () => {
        const token = new URLSearchParams(history.location.search).get("token");

        if (token) {
            try {
                const data = await loginFromAdminRequest(token);

                if (data.response) {
                    clearLocalStorage();

                    const user = data.response.user;

                    const sessionToken = {
                        accessToken: data.response.accessToken,
                        refreshToken: data.response.refreshToken,
                    };
                    storeSessionToken(sessionToken);
                    dispatch({ type: ACTIONS.LOGIN, token: sessionToken });

                    dispatch({
                        type: ACTIONS.SET_USER,
                        user: user,
                    });

                    // Recording the login must not stop the redirect.
                    await updateAnalytics({ lastLogin: Date() }).catch(
                        () => undefined
                    );

                    if (user && !user.firstLoginWeb) {
                        localStorage.setItem("preview-video", "1");
                    }

                    history.push("/app/lets-play");
                }
            } catch (error) {
                toast.error(
                    "There was an error logging you in automatically, please try it yourself."
                );
                history.push("/");
            }
        }
    };

    /*
     * Mount-only, and it must be: `handleInit` consumes a one-shot bridge token from the URL
     * and logs the visitor in. Running it again would try to consume a token that is already
     * spent. `handleInit` is recreated every render, so adding it is a loop, not a fix.
     */
    useEffect(() => {
        handleInit();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <></>;
};

export default LoginFromAdmin;
